import { authorized, authorizedLoader, isAdminUser } from '../../../utils/loaders.ts';
import { organizationListLoader } from './loaders.ts';
import {
    ADMIN_ORGANIZATION_ADD_PATH,
    ADMIN_ORGANIZATION_EDIT_LIMITS_PATH,
    ADMIN_ORGANIZATION_LIST_PATH,
} from './paths.ts';

export default [
    {
        handle: {
            title: ['admin:organizationListPage.documentTitle'],
        },
        path: ADMIN_ORGANIZATION_LIST_PATH,
        lazy: async () => ({ Component: (await import('./pages/OrganizationListPage.tsx')).default }),
        loader: authorizedLoader(organizationListLoader, isAdminUser),
        children: [
            {
                handle: {
                    title: ['admin:organizationListPage.addDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_ADD_PATH,
                lazy: async () => ({
                    Component: (await import('./pages/OrganizationListPage.tsx')).AddOrganizationFormDialog,
                }),
                loader: authorized(isAdminUser),
            },
            {
                handle: {
                    title: ['admin:organizationListPage.editLimitsDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_EDIT_LIMITS_PATH,
                lazy: async () => ({
                    Component: (await import('./pages/OrganizationListPage.tsx')).EditOrganizationLimitsFormDialog,
                }),
                loader: authorized(isAdminUser),
            },
        ],
    },
];
